<template>
  <StyledText
    ref="targetEl"
    :fontId="fontId"
    :tag="tag"
    :class="[testClassName]"
  >
    <slot />
  </StyledText>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import StyledText from "./styled/Text.vue";
import { Brand } from "@fresh8/types/src/index";

export default defineComponent({
  name: "Text",
  components: {
    StyledText
  },
  props: {
    tag: {
      type: String as PropType<"p" | "span" | "div">,
      required: false,
      default: "p"
    },
    styleGroup: {
      type: String,
      required: true
    },
    get: {
      type: Function as PropType<
        (brand: Brand | undefined) => string | undefined
      >,
      required: true
    },
    set: {
      type: Function as PropType<(brand: Brand, value: string) => void>,
      required: true
    }
  },
  setup(props) {
    const brandContext = injectBrand();

    const fontId = computed(
      () =>
        props.get(brandContext?.brand.value) ||
        Object.keys(brandContext?.brand.value?.fonts || {})[0]
    );

    const { targetEl } = composePopoverForm(props.styleGroup, [
      {
        type: "font",
        get: () => {
          return (
            props.get(brandContext?.brand.value) ||
            Object.keys(brandContext?.brand.value?.fonts || {})[0]
          );
        },
        set: (value: string) => {
          if (brandContext?.brand?.value) {
            props.set(brandContext.brand.value, value);
          }
        }
      }
    ]);

    return {
      fontId,
      targetEl,
      testClassName: computed(
        () =>
          "text-style-" +
          props.styleGroup
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
